'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../../../_virtual/index.cjs');
var Pill_web = require('../../atoms/Pill/Pill.web.cjs');
var Tooltip_web = require('../../atoms/Tooltip/Tooltip.web.cjs');
var reactFontawesome = require('../../../react-fontawesome/react-fontawesome.cjs');
var AvailabilityStatusPill_web_styles = require('./AvailabilityStatusPill.web.styles.cjs');

/**
 * Pill or icon to display the availability status of a product or service.
 *
 * {@link https://aviary.fullscript.io/latest/components/pill-availability/overview-xN33d6hg | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/platform/AvailabilityStatusPill/AvailabilityStatusPill.web.tsx | View in GitLab}
 *
 * @scope Core
 */ const AvailabilityStatusPill = ({ availabilityStatus, tooltipContent, size = "small", pillStyles, customCss, ...rest })=>{
    const { availabilityLabelText, availabilityStatusIcon } = index.cjsExports.getProductAvailabilityLabel(availabilityStatus);
    const currentTheme = react.useTheme();
    if (!availabilityLabelText) {
        return null;
    }
    const getBackgroundColor = ()=>{
        switch(availabilityStatus){
            case index.cjsExports.AvailabilityStatus.DISCONTINUED:
            case index.cjsExports.AvailabilityStatus.UNAVAILABLE:
            case index.cjsExports.AvailabilityStatus.NA:
                return "critical";
            case index.cjsExports.AvailabilityStatus.BACKORDERED:
                return "warning";
            case index.cjsExports.AvailabilityStatus.TO_BE_DISCONTINUED:
                return "info";
            default:
                return "neutral";
        }
    };
    if (size !== "xxsmall") {
        return /*#__PURE__*/ jsxRuntime.jsx(Pill_web.Pill, {
            intention: getBackgroundColor(),
            size: size,
            icon: availabilityStatusIcon,
            tooltipContent: tooltipContent,
            customCss: [
                pillStyles,
                customCss
            ],
            ...rest,
            children: availabilityLabelText
        });
    }
    return /*#__PURE__*/ jsxRuntime.jsx(Tooltip_web.Tooltip, {
        tooltipContent: `${availabilityLabelText}. ${tooltipContent}`,
        isTooltipHidden: tooltipContent === "",
        children: availabilityStatusIcon && /*#__PURE__*/ jsxRuntime.jsx(reactFontawesome.FontAwesomeIcon, {
            icon: availabilityStatusIcon,
            title: availabilityLabelText,
            "aria-label": availabilityLabelText,
            css: [
                AvailabilityStatusPill_web_styles.icon(currentTheme, getBackgroundColor()),
                customCss
            ],
            ...rest
        })
    });
};

exports.AvailabilityStatusPill = AvailabilityStatusPill;
//# sourceMappingURL=AvailabilityStatusPill.web.cjs.map
